import {useQuery} from 'react-query';

import {evalApi} from 'src/lib/api/eval';

export function useForecastEvaluation(siteId: string, forecastId: string) {
  const {
    data: evaluation,
    isLoading,
    error,
  } = useQuery(
    ['eval', 'site', siteId, 'forecast', forecastId],
    () => evalApi.getForecastEvaluation(siteId, forecastId),
    {enabled: !!siteId && !!forecastId, cacheTime: 0}
  );

  return {evaluation, isLoaded: !isLoading, error};
}

export function useForecasts(
  siteId: string,
  params?: {start?: string; end?: string; model?: string}
) {
  const {
    data: forecasts,
    isLoading,
    error,
  } = useQuery(
    ['eval', 'site', siteId, 'forecasts', params],
    () => evalApi.listForecasts(siteId, params),
    {enabled: !!siteId, cacheTime: 0}
  );

  return {forecasts, isLoaded: !isLoading, error};
}
